<template>
  <div>
    <h6 class="heading-small text-muted mb-4 text-truncate">
      Add Interaction Log
    </h6>

    <form id="form-proper">
      <div class="py-2">
        <div class="row">
          <div class="col">
            <base-input label="Log Type" required>
              <a-select v-model="formData.mi_lt_id">
                <a-select-option
                  v-for="type in interactionTypes"
                  v-bind:value="type.id"
                  v-bind:key="type.id"
                >
                  {{ type.name }}
                </a-select-option>
              </a-select>
              <div v-if="$v.formData.mi_lt_id.$dirty" class="text-danger">
                <div class="error" v-if="!$v.formData.mi_lt_id.required">
                  Field is required
                </div>
              </div>
            </base-input>
          </div>
        </div>

        <div class="row">
          <div class="col">
            <base-input label="Description">
              <a-textarea
                v-model="formData.description"
                :auto-size="{ minRows: 5, maxRows: 5 }"
              />
            </base-input>
          </div>
        </div>
      </div>
      <div class="container">
        <div class="row">
          <div class="col text-right">
            <template>
              <b-button
                size="sm"
                variant="primary"
                @click.prevent="logInteraction"
                :disabled="formSubmitting"
              >
                Submit
              </b-button>
            </template>
          </div>
        </div>
      </div>
    </form>
    <hr />

    <a-card title="Interaction History" :loading="fetchHistories">
      <a-card
        v-for="hist in interactionHistories"
        :key="hist.id"
        :value="hist.id"
        class="mb-3"
      >
        <a-card-grid style="width: 100%" :hoverable="false">
          <div>Log Type: {{ hist.interactionType.name }}</div>
          <div
            v-if="
              typeof hist.creator !== 'undefined' &&
              typeof hist.creator.user_name !== 'undefined'
            "
          >
            Created By: {{ hist.creator.user_name }}
          </div>
          <div>
            Created On:
            {{ moment(hist.created_at).format('MM/DD/YYYY HH:mm:ss') }}
          </div>
        </a-card-grid>
        <a-card-grid style="width: 100%" :hoverable="false">
          <p>{{ hist.description }}</p>
        </a-card-grid>
      </a-card>
    </a-card>
  </div>
</template>

<script>
import HTTPRequest from '../../controllers/httpRequest';
import { required } from 'vuelidate/lib/validators';
import moment from 'moment';

export default {
  name: 'InteractionLogForm',
  props: {
    memberData: Object,
    viewMode: Boolean
  },
  data() {
    return {
      formData: {
        member_id: null,
        mi_lt_id: null,
        description: null
      },
      interactionTypes: [],
      interactionHistories: [],
      formSubmitting: false,
      fetchHistories: false
    };
  },

  validations: {
    formData: {
      mi_lt_id: { required }
    }
  },

  methods: {
    moment,
    async getInteractionTypes() {
      this.fetchHistories = true;
      const data = await HTTPRequest.getRequest(
        '/api/v1/clp_membership_programs/' +
          this.memberData.membership_program_id +
          '/interaction_types'
      );

      this.interactionTypes = data;
      this.fetchHistories = false;
    },

    async logInteraction() {
      this.$v.formData.$touch();

      if (!this.$v.formData.$invalid) {
        this.formSubmitting = true;
        this.formData.member_id = this.memberData.id;
        const response = await HTTPRequest.postRequest(
          '/api/v1/clp_interaction_logs',
          {
            interaction_log: this.formData
          }
        );

        if (response.id) {
          this.$notification.success({
            message: 'Data has been logged.'
          });
          this.getInteractionHistories();

          this.clearForm();
        } else {
          if (response.error != undefined) {
            this.$notification.error({
              message: response.error
            });
          } else {
            this.$notification.error({
              message: 'Something went wrong. Please try again.'
            });
          }
        }
        this.formSubmitting = false;
      }
    },

    async getInteractionHistories() {
      const data = await HTTPRequest.getRequest(
        '/api/v1/clp_interaction_logs/' + this.memberData.id
      );

      this.interactionHistories = data;
    },

    clearForm() {
      this.formData = {
        member_id: null,
        mi_lt_id: null,
        description: null
      };

      this.$v.formData.$reset();
    }
  },
  created() {
    this.getInteractionTypes();
    this.getInteractionHistories();
  }
};
</script>

<style scoped></style>
